import { render, staticRenderFns } from "./setDelivery.vue?vue&type=template&id=8339fe82&scoped=true"
import script from "./setDelivery.vue?vue&type=script&lang=js"
export * from "./setDelivery.vue?vue&type=script&lang=js"
import style0 from "./setDelivery.vue?vue&type=style&index=0&id=8339fe82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8339fe82",
  null
  
)

export default component.exports